export default __webpack_public_path__ + "static/media/iq.842fc40c.svg";